import React from 'react';
import classNames from 'classnames';
import styles from './LoadingSkeleton.module.scss';

export interface LoadingSkeletonProps {
  numberOfItems?: number;
  rounded?: boolean;
  className?: string;
  type?: 'rows' | 'cards';
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ numberOfItems = 1, className, rounded, type = 'rows' }) => {
  const array = Array.from({ length: numberOfItems });
  return (
    <div
      className={classNames(styles.root, className, numberOfItems > 1 && 'gap-16', {
        [styles.fullHeight]: numberOfItems === 1 && !rounded,
        [styles.rounded]: rounded,
      })}>
      {numberOfItems &&
        array.map(() => (
          <div key={Math.random().toString(36).substr(2, 9)} className={classNames([styles.skeleton, styles[type]])} />
        ))}
    </div>
  );
};

export default LoadingSkeleton;
